import { logWrapper } from '../../utils';
import swal from 'sweetalert2';

export default {
  myExpiredDocController: [
    'runtimeConstant',
    '$scope',
    '$rootScope',
    'revisionService',
    '$filter',
    '$timeout',
    '$state',
    '$controller',
    'authService',
    'EQuickAccessItems',
    function (
      runtimeConstant,
      $scope,
      $rootScope,
      revisionService,
      $filter,
      $state,
      $controller,
      authService,
      EQuickAccessItems
    ) {
      'use strict';

      function goToPage(page) {
        $state.go('home.myExpiredDoc', { page: page });
      }

      function loadDocuments() {
        if ($scope.currentPage < 1) {
          $scope.goToPage(1);
        } else {
          $rootScope.currentDocument = null;
          $scope.count = 0;

          $scope.description = 'LOADING DOCUMENTS';
          $scope.documents(null);

          $scope.loading = true;

          var folderColumn = $scope.columns.filter((c) => c.id === 'folder')[0];
          if (folderColumn !== undefined && folderColumn !== null)
            folderColumn.disabled = false;

          revisionService.cancelLoadRevisions();
          $rootScope.$broadcast('loadFolder', EQuickAccessItems.MYEXPIREDDOC);

          revisionService
            .loadRevisionsFavorites($scope.currentPage, $scope.pageSize)
            .then((data) => {
              $scope.count = data.length;

              $scope.totalItem = $scope.count;

              if ($scope.totalItem > $scope.limite) {
                $scope.limiteValor = $scope.limite;
                $scope.botaoAtivo = true;
              } else {
                $scope.limiteValor = $scope.totalItem;
                $scope.botaoAtivo = false;
              }

              $scope.pageCount = Math.ceil($scope.count / $scope.pageSize);

              $scope.loading = false;
              if ($scope.pageCount < $scope.currentPage && $scope.count > 0) {
                $scope.goToPage($scope.pageCount);
              } else {
                authService.getUserAsync().then(user => {
                  user.userPreferences.IdLastFolder = EQuickAccessItems.MYEXPIREDDOC;
                });

                $scope.documents(data);

                $scope.groups = [];

                $scope.description = $scope.getDescription(
                  $scope.currentPage,
                  $scope.pageSize,
                  $scope.count,
                  $scope.limiteValor
                );

                if (authService.authentication.email !== 'autologin') {
                  var date = $scope.columns.filter((c) => c.id === 'date')[0];
                  date.sorted = 'asc';
                  $scope.sortColumn(date);
                } else {
                  var title = $scope.columns.filter((c) => c.id === 'title')[0];
                  title.sorted = '';
                  $scope.sortColumn(title);
                }
              }
            })

            .catch((err) => {
              if (
                err.status_code === 500 &&
                $scope.selectedTreeItem.Name === 'CHECKOUTS'
              ) {
                $scope.documents([]);
                return;
              }
              swal.fire(err.error, err.error_description);
            });
        }
      }

      function run() {
        try {
          $controller('baseController', { $scope: $scope });
          $rootScope.$broadcast('clearSearchTerm');
          $scope.autologincolumns = ['icon', 'title', 'description'];
          $scope.title = $filter('translate')('MY EXPIRED DOC');
          $scope.description = '';
          $scope.noDocuments = $filter('translate')('NO EXPIRED DOC');

          if (!$state.params.page) {
            $state.go('home.myExpiredDoc', { page: 1 });
          }

          $scope.currentPage = $state.params.page
            ? parseInt($state.params.page)
            : 1;

          $scope.pageSize = 100;
          $scope.pageCount = 1;
          $scope.groups = null;
          $scope.currentGroup = null;
          $scope.columns = [];
          $scope.canView = false;
          $scope.loading = true;
          $scope.count = 0;

          $scope.goToPage = logWrapper(
            goToPage,
            runtimeConstant.isDebugControllersInternals
          );
          $scope.loadDocuments = logWrapper(
            loadDocuments,
            runtimeConstant.isDebugControllersInternals
          );

          $scope.configColumns();
        } catch (error) {
          // eslint-disable-next-line no-console
          console.error(error);
        }
      }

      // Wrap the setup function with logWrapper for debugging purposes
      logWrapper(run, runtimeConstant.isDebugControllers)();
    },
  ],
};
